<div class="container-fluid">
    <div class="row">
        <div class="col-md-3">
            <div class="card card-total rounded p-3 p-xxl-4 mt-4">
                <div class="card-body border-start border-primary border-3 pt-0 pb-0">
                    <div class="d-flex justify-content-between">
                        <div class="d-flex justify-content-center align-items-center">
                            <div class="fs-1 fw-bold me-3"> {{ opsData?.total || 0 }}</div>
                        </div>
                        <div class="text-center">
                            <i class="bi bi-database fs-1 fw-bold mt-n-15px"></i>
                            <div>Total KYC<br>Customers</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-3">
            <div class="card card-success rounded p-3 p-xxl-4 mt-4">
                <div class="card-body border-start border-success border-3 pt-0 pb-0">
                    <div class="d-flex justify-content-between">
                        <div class="d-flex justify-content-center align-items-center">
                            <div class="fs-1 fw-bold me-3"> {{ opsData?.KYCCompleted || 0 }}</div>
                        </div>
                        <div class="text-center">
                            <i class="bi bi-check fs-1 fw-bold mt-n-15px"></i>
                            <div>Completed KYC<br>Customers</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-3">
            <div class="card card-failed rounded p-3 p-xxl-4 mt-4">
                <div class="card-body border-start border-danger border-3 pt-0 pb-0">
                    <div class="d-flex justify-content-between">
                        <div class="d-flex justify-content-center align-items-center">
                            <div class="fs-1 fw-bold me-3"> {{ opsData?.KYCFailed || 0 }}</div>
                        </div>
                        <div class="text-center">
                            <i class="bi bi-x fs-1 fw-bold mt-n-15px"></i>
                            <div>Failed KYC<br>Customers</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-3">
            <div class="card card-refund rounded p-3 p-xxl-4 mt-4">
                <div class="card-body border-start border-warning border-3 pt-0 pb-0">
                    <div class="d-flex justify-content-between">
                        <div class="d-flex justify-content-center align-items-center">
                            <div class="fs-1 fw-bold me-3"> {{ opsData?.KYCPending || 0 }}</div>
                        </div>
                        <div class="text-center">
                            <i class="bi bi-clock-fill fs-1 fw-bold mt-n-15px"></i>
                            <div>Pending KYC<br>Customers</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-8">
            <div class="border p-3 rounded shadow-sm mt-5 mb-5">
                <p class="primaryColor fs-5 fw-bold">Customers</p>
                <div>
                    <ngx-charts-bar-vertical [scheme]="colorScheme" [results]="barChartSettings.data"
                        [gradient]="barChartSettings.gradient" [barPadding]="40" [xAxis]="barChartSettings.showXAxis"
                        [yAxis]="barChartSettings.showYAxis" [legend]="barChartSettings.showLegend"
                        [showXAxisLabel]="barChartSettings.showXAxisLabel"
                        [showYAxisLabel]="barChartSettings.showYAxisLabel" [xAxisLabel]="barChartSettings.xAxisLabel"
                        [yAxisLabel]="barChartSettings.yAxisLabel" [tooltipDisabled]="false">
                    </ngx-charts-bar-vertical>
                </div>
            </div>
        </div>
        <div class="col-md-4">
            <div class="border p-3 rounded shadow-sm mt-5 mb-5">
                <p class="primaryColor fs-5 fw-bold">KYC Pending</p>
                <div>
                    <ngx-charts-bar-horizontal [scheme]="colorScheme" [results]="kycPendingData"
                        [gradient]="kycPendingPieChartSettings.gradient" 
                        [xAxis]="true" [yAxis]="true" [showXAxisLabel]="true" [showYAxisLabel]="true"
                        [xAxisLabel]="'Count'" [yAxisLabel]="'Country'" [tooltipDisabled]="false">
                    </ngx-charts-bar-horizontal>
                </div>
            </div>
        </div>
    </div>
</div>